"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsPlugin = void 0;
const analytics_provider_1 = require("./analytics-provider");
exports.AnalyticsPlugin = {
    install(vue) {
        vue.prototype.$analyticsIdentify = (data) => {
            analytics_provider_1.AnalyticsProvider.getAnalytics().identify(data);
        };
        vue.prototype.$trackEvent = (eventName, category, properties) => {
            analytics_provider_1.AnalyticsProvider.getAnalytics().trackEvent(eventName, category, properties);
        };
        vue.prototype.$updateIdentity = (data) => {
            analytics_provider_1.AnalyticsProvider.getAnalytics().updateIdentity(data);
        };
        vue.prototype.$trackPage = () => {
            analytics_provider_1.AnalyticsProvider.getAnalytics().trackPage();
        };
        vue.prototype.$logout = () => {
            analytics_provider_1.AnalyticsProvider.getAnalytics().logout();
        };
    }
};
